import { render, staticRenderFns } from "./qs3-04.vue?vue&type=template&id=38394ff8&scoped=true&"
import script from "./qs3-04.vue?vue&type=script&lang=js&"
export * from "./qs3-04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38394ff8",
  null
  
)

export default component.exports